import React, {Component, Fragment} from 'react';
import {Button, Icon, Card, Modal} from 'semantic-ui-react';
import {Document, Paragraph, Packer, TextRun, ImageRun, AlignmentType} from 'docx';
import FileSaver from 'file-saver';
import axios from 'axios';
import * as math from 'mathjs';
import { VictoryGroup, VictoryChart, VictoryBar} from 'victory'
import {Bar} from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import moment from 'moment';
import PremiumSignUpModal from './premiumSignUpModal';

// Register Chart.js components for version 4.x
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const parentAnswerKey = {
    V3Q1: 0,
    V3Q2: 3,
    V3Q3: 0,
    V3Q4: 1
};

const earlyLearningAnswerKey = {
    V3Q5: 0,
    V3Q6: 3,
    V3Q7: 1,
    V3Q8: 0
}

const languageDevelopmentAnswerKey = {
    V3Q9: 4,
    V3Q10: 1,
    V3Q11: 0,
    V3Q12: 0
}

const nutritionAndPhysicalActivityAnswerKey = {
    V3Q13: [0,1,3,4],
    V3Q14: [0,2,3,4],
    V3Q15: 3,
    V3Q16: 1
}

const socioemotionalDevelopmentAnswerKey = {
    V3Q17: 1,
    V3Q18: 3,
    V3Q19: [0,2,3,4],
    V3Q20: 0
}

const useOfTechnologyAnswerKey = {
    V3Q21: [1,2,3],
    V3Q22: 3,
    V3Q23: [0,1,2,4],
    V3Q24: 0,
    V4Q24: 0
}

const mathematicalDevelopmentAnswerKey = {
    V3Q25: 0,
    V3Q26: [0,1,3],
    V3Q27: [0,1,2,3,4],
    V3Q28: 1
}

const schoolReadinessAnswerKey = {
    V3Q29: [0,1,2],
    V3Q30: [0,1,2,3,4],
    V3Q31: 3,
    V3Q32: 0,
    V4Q32: [0,2,3,4]
}

const advocacyAnswerKey = {
    V3Q33: 3,
    V3Q34: [0,2,4],
    V3Q35: 2,
    V3Q36: 0,
    V4Q36: [3],
}

const confidenceAnswerKey = {
    V3Q37: [2,3],
    V3Q38: [2,3],
    V3Q39: [2,3],
    V3Q40: [2,3]
}

class ReportDashboard extends Component{
    state = {
        parentingScores: {},
        earlyLearningScores: {},
        languageDevelopmentScores: {},
        nutritionAndPhysicalActivityScores: {},
        mathematicalDevelopmentScores: {},
        schoolReadinessScores: {},
        advocacyScores: {},
        confidenceScores: {},
        useOfTechnologyScores: {},
        socioemotionalDevelopmentScores: {},
        sites: [],
        selectedSite: 0,
        courseList: [{
            value: '',
            text: 'No Programs Found'
        }],
        courses: [],
        selectedReport: '',
        calculationError: false,
        preScores:[],
        postScores: [],
        sortedCourses: {},
        modalOpen: false,
        numberOfResponses: 0,
        numberOfCompleteParticipants: 0,
        numberOfIncompleteParticipants: 0,
        programId: '',
        premiumSignUpModalOpen: false
    }

    togglePremiumSignUpModal = () => {
        this.setState({
            premiumSignUpModalOpen: !this.state.premiumSignUpModalOpen
        })
    }
    getProgramCSV = () => {
        const siteUrl = `https://zyf7169rj6.execute-api.us-east-1.amazonaws.com/prod/admin/reports/${this.state.programId}`
        const config = {
            headers: {
                "Authorization": `Bearer ${this.props.token}`
            }
        }

        axios.get(siteUrl, config).then( res => {
            const blob = new Blob([res.data.join('\n')], {type: "text/csv;charset=utf-8"})
                FileSaver.saveAs(blob, 'OpeningDoorsProgramReport.csv')

        })
    }

    getMacroReport = () => {
        const siteUrl = 'https://zyf7169rj6.execute-api.us-east-1.amazonaws.com/prod/admin/reports'
        const config = {
            headers: {
                "Authorization": `Bearer ${this.props.token}`
            }
        }

        axios.get(siteUrl, config).then( res => {
            // Parse the response - Lambda now returns JSON with downloadUrl
            const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

            if (data.success && data.downloadUrl) {
                // Download CSV directly from S3 pre-signed URL
                window.location.href = data.downloadUrl;
                console.log(`Generated CSV with ${data.recordCount} records`);
            } else {
                console.error('Failed to generate report:', data.error || 'Unknown error');
                alert('Failed to generate report. Please try again or contact support.');
            }
        }).catch(error => {
            console.error('Report generation error:', error);
            alert('Failed to generate report. Please check your connection and try again.');
        })
    }

    getProgramReport = () => {
        const siteUrl = 'https://zyf7169rj6.execute-api.us-east-1.amazonaws.com/prod/admin/programReport'
        const config = {
            headers: {
                "Authorization": `Bearer ${this.props.token}`
            }
        }

        axios.get(siteUrl, config).then( res => {
            const blob = new Blob([res.data.join('\n')], {type: "text/csv;charset=utf-8"})
                FileSaver.saveAs(blob, 'OpeningDoorsReport.csv')

        })
    }

    handleChange = (event, {name, value}) => {
        this.setState({[name]: value})
    }

    handleReportChange = (event, {name, value}) => {
        this.selectedReport(value);
    }

    selectReport = (report) => {
        this.selectedReport(report);
        this.setState({modalOpen: true, programId: report})
    }
    
    handleModalClose = () => {
        this.setState({modalOpen: false})
    }

    handleSiteChange = (event, {name, value}) => {
        if (this.state.sites[value].Courses) {
            const list = this.state.sites[value].Courses.map( (entry, index) => {
                const output = {
                    value: entry.CourseStartDate,
                    text: entry.CourseStartDate,
                    key: index
                }
                return output
            });
            if (list.length > 0) {
                this.setState({[name]: value, courseList: list})
            } else {
                this.setState({[name]: value, courseList: [{
                    value: '',
                    text: 'No Programs Found'
                }]})
            }
        } else {
            this.setState({[name]: value, courseList: [{
                value: '',
                text: 'No Programs Found'
            }]})
        }
    }

    fetchCourses = () => {
        const siteUrl = 'https://zyf7169rj6.execute-api.us-east-1.amazonaws.com/prod/admin/sites'
        const config = {
            headers: {
                "Authorization": `Bearer ${this.props.token}`
            }
        }
        axios.get(siteUrl, config).then( (response) => {
            const sites = response.data.Items
            for (let i in sites) {
                for (let n in sites[i].Courses) {
                    sites[i].Courses[n].SiteName = sites[i].SiteName;
                    sites[i].Courses[n].SiteId = sites[i].SiteId;
                }
            }

            const courses = sites.reduce( (previous, site) => {
                return previous.concat(site.Courses)
            }, [])
            const courseList = courses.map( (course, index) => {
                const courseItem = {
                    index: index,
                    text: `${course.SiteName} on ${course.PrettyStartDate}`,
                    value: `${course.SiteId}${course.FacilitatorId}${course.CourseStartDate}`
                }
                return courseItem;
            })

            let sortedCourses = {}

            for (let course in courses) {
                if (sortedCourses[courses[course].SiteId]) {
                    sortedCourses[courses[course].SiteId].courses.push(courses[course])
                } else {
                    let courseArray = [];
                    courseArray.push(courses[course])
                    sortedCourses[courses[course].SiteId] = {
                        "siteName": courses[course].SiteName,
                        "courses": courseArray
                    }
                }
            }

            this.setState({
                courses: courses,
                courseList: courseList,
                sortedCourses
            })
        })
    }

    selectedReport = (report) => {
        const config = {
            headers: {
                "Authorization": `Bearer ${this.props.token}`
            }
        }

        const cohortReportDataUrl = `https://zyf7169rj6.execute-api.us-east-1.amazonaws.com/prod/cohort-report?partitionKey=${report}`
        axios.get(cohortReportDataUrl, config).then( (res) => {
            const responses = res.data.Items;
            const responseInfo = res.data.Info;

            // Count participants by survey completion status
            const numberOfPreSurveys = responses.reduce( (previous, current) => {
                if (current.preSurveyAnswers && current.preSurveyAnswers.length) {
                    return previous + 1
                } else {
                    return previous
                }
            }, 0);
            const numberOfPostSurveys = responses.reduce( (previous, current) => {
                if (current.postSurveyAnswers && current.postSurveyAnswers.length) {
                    return previous + 1
                } else {
                    return previous
                }
            }, 0);

            // Filter to only include participants with BOTH surveys
            const filteredResponses = responses.filter( (value) => {
                return (value && value.preSurveyAnswers && value.postSurveyAnswers);
            });

            // Calculate how many participants are excluded
            const numberOfCompleteParticipants = filteredResponses.length;
            const numberOfIncompleteParticipants = responses.length - numberOfCompleteParticipants;

            // Log diagnostic information
            console.log('Report Data Summary:', {
                totalParticipants: responses.length,
                completeParticipants: numberOfCompleteParticipants,
                incompleteParticipants: numberOfIncompleteParticipants,
                preSurveysCollected: numberOfPreSurveys,
                postSurveysCollected: numberOfPostSurveys,
                programInfo: responseInfo
            });
            const preSurveys = this.transformPreSurveyResponses(filteredResponses);
            const postSurveys = this.transformPostSurveyResponses(filteredResponses);
            const parentingScores = this.calculateScores(preSurveys, postSurveys, parentAnswerKey, responses);
            const earlyLearningScores = this.calculateScores(preSurveys, postSurveys, earlyLearningAnswerKey, responses);
            const languageDevelopmentScores = this.calculateScores(preSurveys, postSurveys, languageDevelopmentAnswerKey, responses);
            const nutritionAndPhysicalActivityScores = this.calculateScores(preSurveys, postSurveys, nutritionAndPhysicalActivityAnswerKey, responses);
            const socioemotionalDevelopmentScores = this.calculateScores(preSurveys, postSurveys, socioemotionalDevelopmentAnswerKey, responses);
            const useOfTechnologyScores = this.calculateScores(preSurveys, postSurveys, useOfTechnologyAnswerKey, responses);
            const mathematicalDevelopmentScores = this.calculateScores(preSurveys, postSurveys, mathematicalDevelopmentAnswerKey, responses);
            const schoolReadinessScores = this.calculateScores(preSurveys, postSurveys, schoolReadinessAnswerKey, responses);
            const advocacyScores = this.calculateScores(preSurveys, postSurveys, advocacyAnswerKey, responses);
            const confidenceScores = this.calculateScores(preSurveys, postSurveys, confidenceAnswerKey, responses);
            const selectedSiteName = responseInfo.SiteName;
            const selectedFacilitatorName = responseInfo.FacilitatorName;
            const selectedStartDate = responseInfo.StartDate;
            const selectedOrganizationName =  responseInfo.OrganizationName;
            this.setState({
                parentingScores,
                earlyLearningScores,
                languageDevelopmentScores,
                nutritionAndPhysicalActivityScores,
                socioemotionalDevelopmentScores,
                useOfTechnologyScores,
                mathematicalDevelopmentScores,
                schoolReadinessScores,
                advocacyScores,
                confidenceScores,
                selectedReport: report,
                numberOfResponses: responses.length,
                numberOfPreSurveys,
                numberOfPostSurveys,
                numberOfCompleteParticipants,
                numberOfIncompleteParticipants,
                selectedSiteName,
                selectedFacilitatorName,
                selectedStartDate,
                selectedOrganizationName
            })
        })
    }
    componentDidMount() {
        this.fetchCourses();

    }

    biographicData = (postSurveys) => {
        let languageCount = {
            English: 0,
            Spanish: 0,
            Chinese: 0,
            Tagalog: 0,
            Vietnamese: 0,
            Arabic: 0,
            French: 0,
            Korean: 0,
        }

        let educationCount = {
            gradeSchool: 0,
            someHighSchool: 0,
            postHighSchool: 0
        }

        let ethnicCount = {
            white: 0,
            black: 0,
            latino: 0,
            eastAsian: 0,
            southAsian: 0,
            middleEastern: 0,
            nativeAmerican: 0
        }

        const languages = postSurveys.map( survey => {
            return survey['V3Q41']
        });

        const educations = postSurveys.map( survey => {
            return survey['V3Q43']
        });

        const ethnicities = postSurveys.map( survey => {
            if (survey['V3Q42'].length > 1) {
                return survey['V3Q42'].split(',');
            } else {
                return survey['V3Q42']
            }
        });

        function raceMap(race){
            switch (race) {
                case 0:
                    return (
                        ethnicCount.white = ++ethnicCount.white
                    )
                case 1:
                    return (
                        ethnicCount.black = ++ethnicCount.black
                    )
                case 2:
                    return (
                        ethnicCount.latino = ++ethnicCount.latino
                    )
                case 3:
                    return (
                        ethnicCount.eastAsian = ++ethnicCount.eastAsian
                    )
                case 4:
                    return (
                        ethnicCount.southAsian = ++ethnicCount.southAsian
                    )
                case 5:
                    return (
                        ethnicCount.middleEastern = ++ethnicCount.middleEastern
                    )
                case 6:
                    return (
                        ethnicCount.nativeAmerican = ++ethnicCount.nativeAmerican
                    )
                default:
                    return null
            }
        }

        ethnicities.map( entry => {
            if (entry.length > 1) {
                return entry.map( race => {
                    return raceMap(race)
                })
            } else {
                return raceMap(entry)
            }
        });

        educations.map( entry => {
            switch (entry) {
                case 0:
                    return (
                        educationCount.gradeSchool = ++ educationCount.gradeSchool
                    )
                case 1:
                    return (
                        educationCount.someHighSchool = ++ educationCount.someHighSchool
                    )
                case 2:
                    return (
                        educationCount.postHighSchool = ++educationCount.postHighSchool
                    )
                default:
                    return null
            }
        })

        languages.map( (entry) => {
            switch (entry) {
                case 0:
                    return (
                        languageCount.English = ++languageCount.English
                    )
                case 1:
                    return (
                        languageCount.Spanish = ++languageCount.Spanish
                    )
                case 2:
                    return (
                        languageCount.Chinese = ++languageCount.Chinese
                    )
                case 3:
                    return (
                        languageCount.Tagalog = ++ languageCount.Tagalog
                    )
                default:
                    return null
            }
        });

        return {languageCount, educationCount, ethnicCount};


    }

    transformPreSurveyResponses = (responses) => {
        const preSurveyResponses = responses.map( (response) => {
            return response.preSurveyAnswers.reduce( (obj, answer) => {
                let questionId = Object.keys(answer)[0]
                obj[questionId] = answer[questionId];
                return obj
            }, {})
        });
        return preSurveyResponses;
    }

    transformPostSurveyResponses = (responses) => {
        const postSurveyResponses = responses.map( (response) => {
            return response.postSurveyAnswers.reduce( (obj, answer) => {
                let questionId = Object.keys(answer)[0]
                obj[questionId] = answer[questionId];
                return obj
            }, {})
        });
        return postSurveyResponses;
    }

    calculateScores =  (preSurveys, postSurveys, answerKey, responses) => {

        function score(surveys, answerKey){
            const answerKeys = Object.keys(answerKey);
            return surveys.map( (survey) => {
                return answerKeys.map( (key) => {
                    if ( !(key in survey)) {
                        return 1
                    } else if (survey[key] && survey[key].length > 0) {
                        let multipleAnswers = survey[key].split(',').sort().join(',');
                        if (multipleAnswers === answerKey[key].join(',')){
                            return 1
                        } else {
                            return 0
                        }
                    } else if (survey[key] === answerKey[key]) {
                        return 1
                    } else if (answerKey.length > 1 && answerKey.indexOf(survey[key]) > -1) {
                        return 1
                    } else if (key in confidenceAnswerKey) {
                        if  (survey[key] >= 2) {
                            return 1
                        } else  {
                            return 0
                        }
                    } else {
                        return 0
                    }
                })
            })
        }

        function perfectScorePercent(scores, answerKey) {
            if (scores.length === 0) return 0;
            const perfectScores = scores.reduce( (prev, current) => {
                let count =  0;
                if ( current.filter( value => value === 1).length === Object.keys(answerKey).length) {
                    count = 1;
                }
                return prev = prev + count;
            }, 0)

            return ( (perfectScores / scores.length) * 100);
        }

        function perfectScores(scores, answerKey) {
            const perfectScores = scores.reduce( (prev, current) => {
                let count =  0;
                if ( current.filter( value => value === 1).length === Object.keys(answerKey).length) {
                    count = 1;
                }
                return prev = prev + count;
            }, 0)

            return perfectScores;
        }

    
        
        const preScores = score(preSurveys, answerKey);
        const postScores = score(postSurveys, answerKey);
        const prePerfectPercent = math.round(perfectScorePercent(preScores, answerKey), 2);
        const postPerfectPercent = math.round(perfectScorePercent(postScores, answerKey), 2);
        const prePerfect = perfectScores(preScores, answerKey);
        const postPerfect = perfectScores(postScores, answerKey);

        return {
            preScores, 
            postScores,
            totalPre: preSurveys.length, 
            totalPost: postSurveys.length,
            prePerfectPercent,
            postPerfectPercent,
            prePerfect,
            postPerfect
        }
    }

    makeDoc = () => {
        const baseFontSize = 24;
        const buildRun = (text, options = {}) => new TextRun({
            text,
            size: baseFontSize,
            ...options
        });
        const buildParagraph = (children = [], options = {}) => new Paragraph({
            children,
            ...options
        });

        // Get all chart canvases - react-chartjs-2 v5 applies className directly to the canvas element
        const chartCanvases = document.getElementsByClassName('downloadChart');
        const buildChartImage = (index) => {
            const canvas = chartCanvases[index];
            if (!canvas || typeof canvas.toDataURL !== 'function') {
                console.warn(`Chart canvas at index ${index} not found`);
                return null;
            }

            try {
                return buildParagraph([
                    new ImageRun({
                        data: canvas.toDataURL('image/png'),
                        transformation: {
                            width: 600,
                            height: 350
                        }
                    })
                ], {alignment: AlignmentType.CENTER});
            } catch (error) {
                console.error(`Error generating chart image ${index}:`, error);
                return null;
            }
        };

        const startHeading = buildParagraph([
            buildRun('Abriendo Puertas/Opening Doors, 3rd Edition Evaluation', {bold: true})
        ], {alignment: AlignmentType.CENTER});
        const startHeadingA = buildParagraph([
            buildRun(`${this.state.selectedOrganizationName} At ${this.state.selectedSiteName} by ${this.state.selectedFacilitatorName} starting on ${moment(this.state.selectedStartDate).format('MMMM Do YYYY')}`, {bold: true})
        ], {alignment: AlignmentType.CENTER});
        const startHeading2 = buildParagraph([], {alignment: AlignmentType.CENTER, spacing: {after: 360}});
        const communityParagraph = buildParagraph([
            buildRun('About Our Community. ', {bold: true})
        ], {spacing: {after: 240}});
        const communityParagraph2 = buildParagraph([
            buildRun('Programs insert community description here.', {color: 'ff0000'})
        ], {spacing: {after: 240}});
        const methodParagraph = buildParagraph([
            buildRun('Method', {bold: true})
        ], {alignment: AlignmentType.CENTER, spacing: {after: 360}});
        const resultsParagraph = buildParagraph([
            buildRun('Results', {bold: true})
        ], {alignment: AlignmentType.CENTER, spacing: {after: 360}});
        const participantParagraph = buildParagraph([
            buildRun('Participants. ', {bold: true}),
            buildRun('Our evaluation reflects the '),
            buildRun(`${this.state.numberOfCompleteParticipants} parents `, {color: 'ff0000'}),
            buildRun('who completed both Session 1 Survey and Session 10 Survey. '),
            ...(this.state.numberOfIncompleteParticipants > 0 ? [
                buildRun(`Note: ${this.state.numberOfIncompleteParticipants} participant${this.state.numberOfIncompleteParticipants !== 1 ? 's were' : ' was'} excluded from this analysis because they only completed one survey. `, {color: 'ff6600'}),
                buildRun(`Total participants enrolled: ${this.state.numberOfResponses}. `, {color: 'ff6600'})
            ] : []),
            buildRun('Survey collection: '),
            buildRun(`${this.state.numberOfPreSurveys} pre-surveys and ${this.state.numberOfPostSurveys} post-surveys.`)
        ], {spacing: {after: 240}});
        const paragraph1 = buildParagraph([
            buildRun('Abriendo Puertas/Opening Doors (AP/OD). ', {bold: true}),
            buildRun('is a comprehensive, 10-session parenting skills and advocacy program developed by and for low-income parents with children ages 0 to 5. Since its launch in 2007, it has grown rapidly in scope and impact to meet the needs of parents nationwide. Drawing from the real-life experiences of parents, and local data about their schools and communities, sessions are filled with interactive activities that aim to develop parents’ self-understanding as powerful agents of change to improve the lives of their children. The information is presented in ways that are easy for parents to understand and act on within their daily lives. This unique curriculum builds on participants’ cultural strengths to transform the achievement gap into an opportunity to improve and enrich the lives of their children and families.')
        ], {spacing: {after: 240}});
        const procedure = buildParagraph([
            buildRun('Procedure. ', {bold: true}),
            buildRun('To understand our program’s effectiveness we measured participants’ knowledge gains after participating in Abriendo Puertas/Opening Doors. We asked parents to complete a survey in the first session (Session 1 Survey), and again in the last session (Session 10 Survey). By comparing participants’ answers to the questions before and after Abriendo Puertas/Opening Doors, we can better understand how much they learned.')
        ], {spacing: {after: 240}});
        const procedure2 = buildParagraph([
            buildRun('There are 40 questions about the 10 Sessions that cover 10 key dimensions: Parenting, Early learning, Language and literacy development, Nutrition and physical activity, Socioemotional development, Use of technology, Mathematical development, School readiness, Advocacy, and Confidence. Each dimension (and Session) had 4 multiple-choice or true-false questions.')
        ], {spacing: {after: 240}});
        const paragraph2 = buildParagraph([
            buildRun('Parenting. ', {bold: true}),
            buildRun('In this section, parents were assessed on their general knowledge about children’s learning, and setting goals to promote their children’s well-being. Topics included when children’s learning starts and how parents can improve their children’s school success. Before participating in the AP/OD program, '),
            buildRun(`${this.state.parentingScores.prePerfectPercent}% of parents `, {color: 'ff0000'}),
            buildRun('correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.parentingScores.postPerfectPercent}% of the parents `, {color: 'ff0000'}),
            buildRun('did')
        ], {spacing: {after: 240}});

        const paragraph4 = buildParagraph([
            buildRun('Early learning. ', {bold: true}),
            buildRun('The early learning section of the survey examined parents’ general knowledge about how children’s brains develop, and how young children learn. Specifically, parents were asked about the most important time period for children’s brain development, the most important areas of children’s development, and the consequences of stress on the brain. Before participating in the AP/OD program, '),
            buildRun(`${this.state.earlyLearningScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.earlyLearningScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const paragraph6 = buildParagraph([
            buildRun('Language and literacy development. ', {bold: true}),
            buildRun('In the language and literacy development scale, parents were assessed on their knowledge of the foundations for communication and on how to support the development of strong language and literacy skills. Parents were asked, among other questions, about the consequences of using two languages, and about the means to promote language skills. Before participating in the AP/OD program, '),
            buildRun(`${this.state.languageDevelopmentScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.languageDevelopmentScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const paragraph8 = buildParagraph([
            buildRun('Nutrition and physical activity. ', {bold: true}),
            buildRun('Parents were assessed on their knowledge of basic health information pertaining to diet and exercise for themselves and their children. Questions focused on the consequences of spending too much time in front of a screen, the benefits of playtime, and the most effective ways to promote a healthy lifestyle. Before participating in the AP/OD program, '),
            buildRun(`${this.state.nutritionAndPhysicalActivityScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.nutritionAndPhysicalActivityScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const paragraph10 = buildParagraph([
            buildRun('Socioemotional Development. ', {bold: true}),
            buildRun('The AP/OD survey tapped parents’ understanding of children’s social-emotional development. Parents were asked four questions about supporting children’s social-emotional development. For example, parents were asked to define positive social-emotional skills, how they can help their child learn to express her/his feelings constructively, and the impact of parental socioemotional health on their child’s development. Before participating in the AP/OD program, '),
            buildRun(`${this.state.socioemotionalDevelopmentScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.socioemotionalDevelopmentScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const paragraph12 = buildParagraph([
            buildRun('Use of technology. ', {bold: true}),
            buildRun('On this scale, parents were asked how they can ensure their children benefit from what technology has to offer. Topics included good practices around the use of technology, and criteria for choosing shows and apps for children. Before participating in the AP/OD program, '),
            buildRun(`${this.state.useOfTechnologyScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.useOfTechnologyScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const paragraph14 = buildParagraph([
            buildRun('Mathematical development. ', {bold: true}),
            buildRun('The mathematical development section examined parents’ knowledge of children’s mathematical learning, and on the promotion of strong mathematical skills through everyday activities. Questions included the age at which age children start developing mathematical abilities and defining some essential math skills. Before participating in the AP/OD program, '),
            buildRun(`${this.state.mathematicalDevelopmentScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.mathematicalDevelopmentScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const paragraph16 = buildParagraph([
            buildRun('School readiness. ', {bold: true}),
            buildRun('To assess parents’ knowledge and beliefs regarding school readiness, they were asked about what they can do now to help their young children succeed later in school. For example, they were asked about the actions that reflect strong parental involvement or how parents can improve their child’s opportunities to do well in school. Before participating in the AP/OD program, '),
            buildRun(`${this.state.schoolReadinessScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.schoolReadinessScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const paragraph18 = buildParagraph([
            buildRun('Advocacy. ', {bold: true}),
            buildRun('In this final scale, parents were asked about their confidence with regards to their parenting skills, their ability to teach their children their home language and basic skills for school, and their ability to advocate for their children’s needs. Before participating in the AP/OD program, '),
            buildRun(`${this.state.advocacyScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.advocacyScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const paragraph20 = buildParagraph([
            buildRun('Confidence. ', {bold: true}),
            buildRun('In this final scale, parents were asked about their confidence with regards to their parenting skills, their ability to teach their children their home language and basic skills for school, and their ability to advocate for their children’s needs. Before participating in the AP/OD program, '),
            buildRun(`${this.state.confidenceScores.prePerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of parents correctly answered all the questions in this dimension; after the program, '),
            buildRun(`${this.state.confidenceScores.postPerfectPercent}% `, {color: 'ff0000'}),
            buildRun('of the parents did.')
        ], {spacing: {after: 240}});

        const docChildren = [
            startHeading,
            startHeadingA,
            startHeading2,
            paragraph1,
            communityParagraph,
            communityParagraph2,
            methodParagraph,
            participantParagraph,
            procedure,
            procedure2,
            resultsParagraph,
            paragraph2,
            buildChartImage(0),
            paragraph4,
            buildChartImage(1),
            paragraph6,
            buildChartImage(2),
            paragraph8,
            buildChartImage(3),
            paragraph10,
            buildChartImage(4),
            paragraph12,
            buildChartImage(5),
            paragraph14,
            buildChartImage(6),
            paragraph16,
            buildChartImage(7),
            paragraph18,
            buildChartImage(8),
            paragraph20,
            buildChartImage(9)
        ].filter(Boolean);

        const doc = new Document({
            sections: [
                {
                    children: docChildren
                }
            ]
        });

        Packer.toBlob(doc).then(blob => {
            FileSaver.saveAs(blob, 'report.docx')
        })
    }

    renderBarGraph = (data, length) => {
        return (
            <Bar
                className="downloadChart"
                width={600}
                height={350}
                style={{
                    position: 'absolute',
                    left: '-9999px',
                    width: '600px',
                    height: '350px'
                }}
                data={{
                    labels: [`Pre: ${data[1]}`, `Post: ${data[2]}`],
                    datasets: [{
                        label: 'Scores',
                        data: [data[1], data[2]],
                        backgroundColor: 'rgb(0, 75, 143)',
                        barPercentage: 0.4,
                        categoryPercentage: 0.5
                    }]
                }}
                options={{
                    responsive: false,
                    maintainAspectRatio: true,
                    animation: false,
                    devicePixelRatio: 3,
                    scales: {
                        x: {
                        },
                        y: {
                            beginAtZero: true,
                            ticks: {
                                precision: 0
                            },
                            suggestedMax: length,
                            grid: {
                                color: "rgba(0, 0, 0, 0)"
                            }
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            position: 'bottom',
                            text: `${data[0]}`,
                            font: {
                                size: 14
                            },
                            color: 'rgb(37, 37, 37)'
                        },
                        legend: {
                            display: false
                        }
                    }
                }}
            />
        )
    }
    render(){
        const nonDeletedCourses = (courses) =>  {
            return courses.reduce((acc, course) => {
                if (course.deleted) {
                    return acc
                } else  {
                    return acc + 1
                }
            }, 0 )
        };

        const chartData2 = [
            ['Parenting', this.state.parentingScores.prePerfect, this.state.parentingScores.postPerfect],
            ['Early Learning', this.state.earlyLearningScores.prePerfect, this.state.earlyLearningScores.postPerfect],
            ['Language and Literacy Development', this.state.languageDevelopmentScores.prePerfect, this.state.languageDevelopmentScores.postPerfect],
            ['Nutritional and Physical Activity', this.state.nutritionAndPhysicalActivityScores.prePerfect, this.state.nutritionAndPhysicalActivityScores.postPerfect],
            ['Socioemotional Development', this.state.socioemotionalDevelopmentScores.prePerfect, this.state.socioemotionalDevelopmentScores.postPerfect],
            ['Use of Technology', this.state.useOfTechnologyScores.prePerfect, this.state.useOfTechnologyScores.postPerfect],
            ['Mathematical Development', this.state.mathematicalDevelopmentScores.prePerfect, this.state.mathematicalDevelopmentScores.postPerfect],
            ['School Readiness', this.state.schoolReadinessScores.prePerfect, this.state.schoolReadinessScores.postPerfect],
            ['Advocacy', this.state.advocacyScores.prePerfect, this.state.advocacyScores.postPerfect],
            ['Confidence', this.state.confidenceScores.prePerfect, this.state.confidenceScores.postPerfect]
        ]
        const chartData = [
            {
                'domain': 'Parenting',
                'prePerfect': this.state.parentingScores.prePerfect,
                'postPerfect': this.state.parentingScores.postPerfect
            },
            {
                'domain': 'Early Learning',
                'prePerfect': this.state.earlyLearningScores.prePerfect,
                'postPerfect': this.state.earlyLearningScores.postPerfect
            },
            {
                'domain': 'Language and Literacy Development',
                'prePerfect': this.state.languageDevelopmentScores.prePerfect,
                'postPerfect': this.state.languageDevelopmentScores.postPerfect
            },
            {
                'domain': 'Nutritional and Physical Activity',
                'prePerfect': this.state.nutritionAndPhysicalActivityScores.prePerfect,
                'postPerfect': this.state.nutritionAndPhysicalActivityScores.postPerfect
            },
            {
                'domain': 'Socioemotional Development',
                'prePerfect': this.state.socioemotionalDevelopmentScores.prePerfect,
                'postPerfect': this.state.socioemotionalDevelopmentScores.postPerfect
            },
            {
                'domain': 'Use of Technology',
                'prePerfect': this.state.useOfTechnologyScores.prePerfect,
                'postPerfect': this.state.useOfTechnologyScores.postPerfect
            },
            {
                'domain': 'Mathematical Development',
                'prePerfect': this.state.mathematicalDevelopmentScores.prePerfect,
                'postPerfect': this.state.mathematicalDevelopmentScores.postPerfect
            },
            {
                'domain': 'School Readiness',
                'prePerfect': this.state.schoolReadinessScores.prePerfect,
                'postPerfect': this.state.schoolReadinessScores.postPerfect
            },
            {
                'domain': 'Advocacy',
                'prePerfect': this.state.advocacyScores.prePerfect,
                'postPerfect': this.state.advocacyScores.postPerfect
            },
            {
                'domain': 'Confidence',
                'prePerfect': this.state.confidenceScores.prePerfect,
                'postPerfect': this.state.confidenceScores.postPerfect
            }
        ]
        return (
            <Fragment>
                <Card.Group>
                {
                    this.props.role === 'admin' ? 
                    <Card key='report' className={'extra'}>
                        <Card.Content>
                            <Card.Header key="main-report">
                                Reporting
                            </Card.Header>
                        </Card.Content>
                        <Card.Content extra>
                            <Button primary onClick={this.getMacroReport}>Raw CSV Data</Button>
                            <Button primary onClick={this.getProgramReport}>Program Report</Button>
                        </Card.Content>
                    </Card> :
                    null
                }
                {
                    /*
                    window.location.search === '?preview=true' && (this.props.role === 'admin' || this.props.role === 'orgAdmin') ? 
                    <Card key='report'>
                        <Card.Content>
                            <Card.Header key="main-report">
                                Premium Reporting
                            </Card.Header>
                        </Card.Content>
                        <Card.Content extra>
                            {
                                this.props.pTill > 0 && this.props.pTill > Date.now() ?
                                <Button positive>Additional Reports</Button> :
                                <Button positive onClick={this.togglePremiumSignUpModal}>More Reports</Button>

                            }
                        </Card.Content>
                    </Card> :
                    null
                    */
                }
                {
                    Object.keys(this.state.sortedCourses).sort( (a,b) => {
                        if (this.state.sortedCourses[a].siteName.trim().toUpperCase() < this.state.sortedCourses[b].siteName.trim().toUpperCase()) {
                            return -1
                        }
                        if (this.state.sortedCourses[a].siteName.trim().toUpperCase() > this.state.sortedCourses[b].siteName.trim().toUpperCase()) {
                            return 1
                        }
                        return 0
                    }).map( (site) => {
                        return (
                            <Card key={this.state.sortedCourses[site].siteName}>
                                <Card.Content key={`${site}card`}>
                                    <Card.Header>
                                        {this.state.sortedCourses[site].siteName}
                                    </Card.Header>
                                    <Card.Description>
                                        {nonDeletedCourses(this.state.sortedCourses[site].courses)} program{nonDeletedCourses(this.state.sortedCourses[site].courses) > 1 || this.state.sortedCourses[site].courses.length === 0 ? 's' : ''}
                                    </Card.Description>
                                </Card.Content>
                                <Card.Content extra key={`${site}InnerCard`}>
                                    {
                                        this.state.sortedCourses[site].courses.filter( course => !course.deleted).map( course => {
                                            return (
                                                <Button primary key={course.CourseStartDate} className="report-button" onClick={() => this.selectReport(`${course.SiteId}${course.FacilitatorId}${course.CourseStartDate}`)}>{course.PrettyStartDate}</Button>
                                            )
                                        })
                                    }
                                </Card.Content>
                            </Card>
                        )
                    })
                }
                </Card.Group>
                <Modal open={this.state.modalOpen} onClose={this.handleModalClose} size="large" closeIcon>
                    <Modal.Header>
                        Abriendo Puertas/Opening Doors, 3rd Edition Evaluation<br/>
                        {this.state.selectedOrganizationName} at {this.state.selectedSiteName} by {this.state.selectedFacilitatorName} starting on {moment(this.state.selectedStartDate).format('MMMM Do YYYY')}
                    </Modal.Header>
                    <Modal.Content>
                        { this.state.selectedReport && this.state.parentingScores.totalPost > 0 ?
                        <Fragment>
                                <Button onClick={this.makeDoc} className="report-download">
                                    Download Selected Report &nbsp;<Icon name="disk"/>
                                </Button>
                                {
                                this.props.role === 'admin' || this.props.role === 'orgAdmin' ?
                                <Button onClick={this.getProgramCSV} className="report-download">Download CSV</Button> :
                                null
                                }

                                <p className="test1"> <b>About Abriendo Puertas/Opening Doors</b>. Abriendo Puertas/Opening Doors (AP/OD) 
                                    is a comprehensive, 10-session parenting skills and advocacy program 
                                    developed by and for low-income parents with children ages 0 to 5. 
                                    Since its launch in 2007, it has grown rapidly in scope and impact 
                                    to meet the needs of parents nationwide. Drawing from the real-life
                                    experiences of parents, and local data about their schools and communities, 
                                    sessions are filled with interactive activities that aim to develop parents’
                                    self-understanding as powerful agents of change to improve the lives of their
                                    children. The information is presented in ways that are easy for parents
                                    to understand and act on within their daily lives. This unique curriculum
                                    builds on participants’ cultural strengths to transform the achievement
                                    gap into an opportunity to improve and enrich the lives of their children
                                    and families. 
                                </p>
                                <h2>Results</h2>
                                <p><b>Parenting</b> In this section, parents were assessed on 
                                their general knowledge about children’s learning, and setting goals 
                                to promote their children’s well-being. Topics included when children’s 
                                learning starts and how parents can improve their children’s school success.
                                Before participating in the AP/OD program, <span className="report-computed"> {this.state.parentingScores.prePerfectPercent}%</span> of parents correctly
                                answered all the questions in this dimension; after the program, <span className="report-computed"> {this.state.parentingScores.postPerfectPercent}%</span> of the parents did.
                                </p>

                                <div height="300px">
                                    <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}} id='screenShot1'>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(0,1)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(0,1)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>

                                {this.renderBarGraph(chartData2[0], this.state.confidenceScores.postScores.length)}

                                <p><b>Early learning</b> The early learning section of the survey examined parents’ general knowledge
                                about how children’s brains develop, and how young children learn. 
                                Specifically, parents were asked about the most important time period 
                                for children’s brain development, the most important areas of children’s 
                                development, and the consequences of stress on the brain. Before participating
                                in the AP/OD program, <span className="report-computed"> {this.state.earlyLearningScores.prePerfectPercent}%</span> of parents correctly answered all the questions in
                                this dimension; after the program, <span className="report-computed"> {this.state.earlyLearningScores.postPerfectPercent}%</span> of the parents did. 
                                </p>

                                <div height="300px">
                                    <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(1,2)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(1,2)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[1], this.state.confidenceScores.postScores.length)}

                                <p>
                                    <b>Language and literacy development</b> In the language and literacy development scale, parents
                                    were assessed on their knowledge of the foundations for
                                    communication and on how to support the development of strong
                                    language and literacy skills. Parents were asked, among other
                                    questions, about the consequences of using two languages,
                                    and about the means to promote language skills. Before
                                    participating in the AP/OD program, <span className="report-computed"> {this.state.languageDevelopmentScores.prePerfectPercent}%</span> of parents correctly
                                    answered all the questions in this dimension; after the program, <span className="report-computed"> {this.state.languageDevelopmentScores.postPerfectPercent}%</span> of the parents did. 
                                </p>

                                <div height="300px">
                                    <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(2,3)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(2,3)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[2], this.state.confidenceScores.postScores.length)}

                                <p><b>Nutrition and physical activity</b> Parents were assessed on their knowledge of basic health information
                                pertaining to diet and exercise for themselves and their children.
                                Questions focused on the consequences of spending too much time in
                                front of a screen, the benefits of playtime, and the most effective
                                ways to promote a healthy lifestyle. Before participating in the
                                AP/OD program, <span className="report-computed"> {this.state.nutritionAndPhysicalActivityScores.prePerfectPercent}%</span> of parents
                                correctly answered all the questions in this dimension; after the program, 
                                <span className="report-computed"> {this.state.nutritionAndPhysicalActivityScores.postPerfectPercent}%</span> of the parents did. 
                                </p>

                                <div height="300px">
                                    <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(3,4)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(3,4)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[3], this.state.confidenceScores.postScores.length)}

                                <p><b>Socioemotional development</b> The AP/OD survey tapped parents’ understanding of children’s social-emotional 
                                development. Parents were asked four questions about supporting children’s
                                social-emotional development. For example, parents were asked to define 
                                positive social-emotional skills, how they can help their child learn to 
                                express her/his feelings constructively, and the impact of parental 
                                socioemotional health on their child’s development. Before participating 
                                in the AP/OD program, <span className="report-computed"> {this.state.socioemotionalDevelopmentScores.prePerfectPercent}%</span> of parents correctly answered all the 
                                questions in this dimension; after the program, <span className="report-computed"> {this.state.socioemotionalDevelopmentScores.postPerfectPercent}%</span> of the parents did. 
                                </p>
                                <div height="300px">
                                    <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(4,5)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(4,5)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[4], this.state.confidenceScores.postScores.length)}

                                <p><b>Use of technology</b> On this scale, parents were asked how they can ensure their children
                                    benefit from what technology has to offer. Topics included good practices
                                    around the use of technology, and criteria for choosing shows and apps for 
                                    children. Before participating in the AP/OD program, <span className="report-computed"> {this.state.useOfTechnologyScores.prePerfectPercent}%</span> of parents correctly 
                                    answered all the questions in this dimension; after the program, <span className="report-computed"> {this.state.useOfTechnologyScores.postPerfectPercent}%</span> of the 
                                    parents did. 
                                </p>

                                <div height="300px">
                                    <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(5,6)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(5,6)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[5], this.state.confidenceScores.postScores.length)}

                                <p><b>Mathematical development</b> The mathematical development section examined parents’ knowledge
                                    of children’s mathematical learning, and on the promotion of strong
                                    mathematical skills through everyday activities. Questions included
                                    the age at which age children start developing mathematical abilities
                                    and defining some essential math skills. Before participating in
                                    the AP/OD program, <span className="report-computed"> {this.state.mathematicalDevelopmentScores.prePerfectPercent}%</span> of parents correctly answered all the
                                    questions in this dimension; after the program, <span className="report-computed"> {this.state.mathematicalDevelopmentScores.postPerfectPercent}%</span> of the
                                    parents did. 
                                </p>

                                <div height="300px">
                                    <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(6,7)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(6,7)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[6], this.state.confidenceScores.postScores.length)}

                                <p><b>School readiness</b> To assess parents’ knowledge and beliefs regarding school readiness,
                                    they were asked about what they can do now to help their young 
                                    children succeed later in school. For example, they were asked about 
                                    the actions that reflect strong parental involvement or how parents 
                                    can improve their child’s opportunities to do well in school. Before 
                                    participating in the AP/OD program, <span className="report-computed"> {this.state.schoolReadinessScores.prePerfectPercent}%</span> of parents correctly 
                                    answered all the questions in this dimension; after the program, 
                                    <span className="report-computed"> {this.state.schoolReadinessScores.postPerfectPercent}%</span> of the parents did. 
                                </p>

                                <div height="300px">
                                <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(7,8)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(7,8)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[7], this.state.confidenceScores.postScores.length)}

                                <p><b>Advocacy</b> Parents’ knowledge of their rights in advocating for their
                                    child was evaluated. Specifically, parents were asked about
                                    their rights to be involved in school-related decision-making;
                                    the practices that can help them advocate for their children; 
                                    and the possible consequences of acting on such practices. 
                                    Before participating in the AP/OD program, <span className="report-computed"> {this.state.advocacyScores.prePerfectPercent}%</span> of parents 
                                    correctly answered all the questions in this dimension; after 
                                    the program, <span className="report-computed"> {this.state.advocacyScores.postPerfectPercent}%</span> of the parents did. 
                                </p>

                                <div height="300px">
                                <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(8,9)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(8,9)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[8], this.state.confidenceScores.postScores.length)}

                                <p><b>Confidence</b> In this final scale, parents were asked about their confidence 
                                    with regards to their parenting skills, their ability to teach 
                                    their children their home language and basic skills for school, 
                                    and their ability to advocate for their children’s needs. Before 
                                    participating in the AP/OD program, <span className="report-computed"> {this.state.confidenceScores.prePerfectPercent}%</span> of parents correctly 
                                    answered all the questions in this dimension; after the program, 
                                    <span className="report-computed"> {this.state.confidenceScores.postPerfectPercent}%</span> of the parents did. 
                                </p>

                                <div height="300px">
                                <VictoryChart domainPadding={30} maxDomain={{ y: this.state.parentingScores.totalPost}}>
                                        <VictoryGroup offset={100} colorScale="blue">
                                            <VictoryBar data={chartData.slice(9,10)} x="domain" y="prePerfect" labels={({ datum }) => `Pre: ${datum.prePerfect}`}/>
                                            <VictoryBar data={chartData.slice(9,10)} x="domain" y="postPerfect" labels={({ datum }) => `Post: ${datum.postPerfect}`}/>
                                        </VictoryGroup>
                                    </VictoryChart>
                                </div>
                                {this.renderBarGraph(chartData2[9], this.state.confidenceScores.postScores.length)}

                                <h3>Participant Summary</h3>
                                <p><b>Complete Participants (included in analysis):</b> {this.state.numberOfCompleteParticipants} participant{this.state.numberOfCompleteParticipants !== 1 ? 's' : ''} with both pre and post surveys</p>
                                {this.state.numberOfIncompleteParticipants > 0 && (
                                    <p style={{color: '#856404', backgroundColor: '#fff3cd', padding: '10px', borderRadius: '4px', border: '1px solid #ffeaa7'}}>
                                        <b>Note:</b> {this.state.numberOfIncompleteParticipants} participant{this.state.numberOfIncompleteParticipants !== 1 ? 's were' : ' was'} excluded from the analysis because they only completed one survey (either pre or post).
                                        Total participants enrolled: {this.state.numberOfResponses}
                                    </p>
                                )}
                                <p><b>Survey Collection:</b> {this.state.numberOfPreSurveys} pre survey{this.state.numberOfPreSurveys !== 1 ? 's' : ''} | {this.state.numberOfPostSurveys} post survey{this.state.numberOfPostSurveys !== 1 ? 's' : ''}</p>

                        </Fragment> :
                        <Fragment>
                            <h3>Participant Summary</h3>
                            <p><b>Survey Collection:</b> {this.state.numberOfPreSurveys} pre survey{this.state.numberOfPreSurveys !== 1 ? 's' : ''} | {this.state.numberOfPostSurveys} post survey{this.state.numberOfPostSurveys !== 1 ? 's' : ''}</p>
                            <p style={{color: '#721c24', backgroundColor: '#f8d7da', padding: '10px', borderRadius: '4px', border: '1px solid #f5c6cb'}}>
                                <b>Not enough data for analysis.</b> Reports require participants to complete both pre and post surveys.
                                {this.state.numberOfResponses > 0 && (
                                    <span> Total participants enrolled: {this.state.numberOfResponses}, but none have completed both surveys yet.</span>
                                )}
                            </p>
                        </Fragment>
                        }    

                    </Modal.Content>

                </Modal>
                <PremiumSignUpModal open={this.state.premiumSignUpModalOpen} onClose={this.togglePremiumSignUpModal} token={this.props.token}></PremiumSignUpModal>
            </Fragment>
        )
    }
}

export default ReportDashboard;
